function getHttpStatus(error: unknown): number | undefined {
    if (error && typeof error === 'object' && 'code' in error && typeof error.code === 'number') {
        return error.code;
    }
    return undefined;
}

export function isPermanentHttpError(error: unknown): boolean {
    const status = getHttpStatus(error);
    return status >= 400 && status < 500 && status !== 408 && status !== 429;
}

export class ChatbotRequestError extends Error {
    constructor(
        public readonly phase: 'post' | 'stream',
        public readonly originalError: unknown,
    ) {
        super(`Chatbot ${phase} request failed.`);
        Object.setPrototypeOf(this, ChatbotRequestError.prototype);
    }

    public get postRejected(): boolean {
        const status = getHttpStatus(this.originalError);
        return this.phase === 'post' && status >= 400 && status < 500 && status !== 408;
    }
}
